const LOGPATH = "/home/pi/logs/logs.json";

console.log("logserver");

import Server from "server";

var logServer = new (class LogServer extends Server {
	constructor(p) {
		super(p);
	}
	RM_log_list(request, from, to) {
		var arrayBuffer = fs.readFileSync(LOGPATH);
		var str = String.fromCharCode.apply(null, new Uint8Array(arrayBuffer));
		var values = JSON.parse(`[${str.replace(/\n/g, ",\n")}{}]`);
		return(values);

		from = new Date(from);
		to = new Date(to);

		values = values.filter(function(value) {
			var dt = new Date(value.dt);
			return (from<=dt && dt<=to);
		});
		return(values);
	}

})();